import React, { useEffect } from 'react';
import styles from './NewPlayerWelcomeModal.module.css';

interface NewPlayerWelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NewPlayerWelcomeModal({ isOpen, onClose }: NewPlayerWelcomeModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <h2 className={styles.modalTitle}>WELCOME TO ZODIAC </h2>

        <div className={styles.modalBody}>
          <p>
            We've set you up with a random quick play for your first match
          </p>
          <p>
            No king or piece selection
          </p>
          <p>
            Your goal is to race your King (the one with the little crown
            above their head) across the board
            <br />
            Or capture your opponent's secret king
          </p>
          <p className={styles.modalHint}>
            Click any piece to see how it moves. Good luck!
          </p>
        </div>

        <button type="button" className={styles.modalButton} onClick={onClose}>
          GOT IT — LET'S PLAY
        </button>
      </div>
    </div>
  );
}
